export enum ExtensionAdminTypeEnum {
  USER = "USER",
  SYSTEM = "SYSTEM",
}
